export default "__VITE_ASSET__CT8Xb5Md__";